export default __webpack_public_path__ + "static/media/gif.55e8ce41.svg";